import { Button, Divider, Form, Input, message, Modal } from "antd";
import { ShopOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useShops } from "../Shops/ShopStore";
import axios from "axios";
import css from "./Pos.module.css";

function ShopRegister({ setKassaStatus }) {
  let { getShops, shops } = useShops();

  let [shop_id, setShopId] = useState();
  let [open, setOpen] = useState(false);
  let [errorRegister, setErrorRegister] = useState(0);
  useEffect(() => {
    getShops();
  }, [getShops]);

  return (
    <>
      <Modal
        centered
        zIndex={9999}
        open={open}
        footer={null}
        title={"Kassa Reestrini yopish"}
        onCancel={() => setOpen(false)}
        width={500}
      >
        <Form
          layout="vertical"
          onFinish={(values) => {
            values.shop_id = shop_id;
            axios
              .post(`closeregister/${errorRegister}`, values)
              .then((res) => {
                message.success(
                  "Kassa Reestrini Yopish muvaffaqiyatli bajarildi"
                );
                localStorage.removeItem("shop_id");
                localStorage.removeItem("start_time");
                setKassaStatus(false);
                setOpen(false);
              })
              .catch((error) => {
                message.error("Kassa Reestrini Yopishda xatolik yuz berdi");
              });
          }}
        >
          <Form.Item name={"end_cash"} label="Kassadagi qoldiqni kiriting">
            <Input size="large" type="number" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Kassani yopish
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <div className={css.registerOverlay}>
        <div className={css.registerCard}>
          <h2 className={css.registerTitle}>
            <ShopOutlined style={{ color: "var(--primary)" }} /> Kassani ochish
          </h2>
          <p className={css.registerSub}>
            Savdoni boshlash uchun kassani tanlang va boshlang'ich qoldiqni kiriting.
          </p>
          <Form
            layout="vertical"
            onFinish={(values) => {
              values.shop_id = shop_id;
              if (!shop_id) {
                message.error("Iltimos kassani tanlang");
                return;
              }
              axios
                .post("shopregister", values)
                .then((res) => {
                  message.success(
                    "Kassa Reestrini ochish muvaffaqiyatli bajarildi"
                  );
                  localStorage.setItem("shop_id", res.data.id);
                  localStorage.setItem("start_time", res.data.start_time);
                  setKassaStatus(false);
                })
                .catch((error) => {
                  if (error?.response?.status === 400) {
                    setOpen(true);
                    setErrorRegister(error?.response?.data?.data?.id);
                  }
                  message.error("Kassa Reestrini ochishda xatolik yuz berdi");
                });
            }}
          >
            <Form.Item label="Kassani tanlang" name={"shop_id"}>
              <div className={css.shopGrid}>
                {shops.map((shop) => (
                  <div
                    key={shop.id}
                    className={`${css.shopCard} ${shop_id === shop.id ? css.shopCardActive : ""}`}
                    onClick={() => setShopId(shop.id)}
                  >
                    <div className={css.shopCardName}>{shop.shopname}</div>
                    <div className={css.shopCardMeta}>
                      {shop.address}<br />
                      {shop.phone}<br />
                      {shop.seller}
                    </div>
                  </div>
                ))}
              </div>
            </Form.Item>
            <Divider style={{ margin: "12px 0" }} />
            <Form.Item name={"start_cash"} label="Kassada qancha mablag' mavjud?">
              <Input size="large" type="number" placeholder="0" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" size="large" htmlType="submit" block>
                Kassani ochish
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ShopRegister;
